import React from 'react'
import { Strategies, View } from '@/components'
import { shareLessonProgress, shareModule } from '@/utils'
import { useLessonCTASideEffects } from '../../hooks'
import { LessonCTAWrapperProps } from '../../types'
import { PrimaryCTA, SecondaryCTA } from '../molecules'
import { ContinueButton } from '../atoms'

export function LessonCTAWrapper(props: LessonCTAWrapperProps) {
  const { chapter, module, origin, type } = props

  const primaryCTA = Strategies.usePrimaryCTA()
  const secondaryCTA = Strategies.useSecondaryCTA()
  const lessonLeave = Strategies.useLessonLeave(origin)

  const onPressCTA = useLessonCTASideEffects(props)

  function handleLeaveLesson() {
    const strategy = lessonLeave.resolve({ module, chapter })
    console.log('Leaving lesson:', strategy)
    onPressCTA(() => strategy?.execute?.({ module, chapter }))
  }

  function handlePressPrimaryCTA() {
    const strategy = primaryCTA.resolve({ module, chapter })

    if (strategy.shouldNavigate) {
      handleLeaveLesson()
      strategy.execute?.({ module, chapter })
      return
    }

    onPressCTA(() => strategy?.execute?.({ module, chapter }))

  }

  async function handlePressSecondaryCTA() {
    const strategy = secondaryCTA.resolve({ module, chapter })

    if (strategy.shouldNavigate) {
      handleLeaveLesson()
      strategy?.execute?.({ module, chapter })
      return
    }

    if (strategy.name === 'share') {
      const shared = (type === 'lesson' ? await shareLessonProgress(chapter) : await shareModule(module))
      handleLeaveLesson()
      strategy?.execute?.({ module, chapter })
      return
    }

    onPressCTA(() => strategy?.execute?.({ module, chapter }))
  }

  return (
    <View variants={['gap:2', 'column', 'fullWidth', 'paddingHorizontal:2']}>
      <PrimaryCTA {...chapter?.primary_cta} strategy={handlePressPrimaryCTA} />
      <SecondaryCTA {...chapter?.secondary_cta} strategy={handlePressSecondaryCTA} />
      <ContinueButton strategy={handleLeaveLesson} />
    </View>
  )
}
